import { useMemo } from "react"
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles"

// Inclui menus e autocompletes renderizados fora do container por portais.
// Os valores históricos e os códigos usados pela API mantêm sua representação.
export default function TemaAcompanhamento({ children }) {
  const atual = useTheme()
  const tema = useMemo(() => createTheme(atual, {
    components: {
      MuiButton: { styleOverrides: { root: { textTransform: "uppercase" } } },
      MuiTab: { styleOverrides: { root: { textTransform: "uppercase" } } },
      MuiContainer: { styleOverrides: { root: { textTransform: "uppercase" } } },
      MuiTypography: { styleOverrides: { root: { textTransform: "uppercase" } } },
      MuiInputBase: { styleOverrides: { input: { textTransform: "uppercase" } } },
      MuiInputLabel: { styleOverrides: { root: { textTransform: "uppercase" } } },
      MuiFormHelperText: { styleOverrides: { root: { textTransform: "uppercase" } } },
      MuiDialog: { styleOverrides: { root: { textTransform: "uppercase" } } },
      MuiMenu: { styleOverrides: { paper: { textTransform: "uppercase" } } },
      MuiAutocomplete: { styleOverrides: {
        popper: { textTransform: "uppercase" },
        option: { textTransform: "uppercase" },
        groupLabel: { textTransform: "uppercase" },
        noOptions: { textTransform: "uppercase" },
      } },
      MuiTooltip: { styleOverrides: { tooltip: { textTransform: "uppercase" } } },
    },
  }), [atual])
  return <ThemeProvider theme={tema}>{children}</ThemeProvider>
}
